import AppLink from './AppLink.vue';

export default AppLink;
